import * as React from 'react'
import BasicImage from '../FacetedCarousel/Card/Packshot/BasicImage'
import * as csm from '../../../utils/csm'
import * as style from './HeroElement.module.scss'
import * as playerStyles from './VideoOverlay.module.scss'
import * as cn from 'classnames'
import VideoOverlay from './VideoOverlay'
import DraperPlayer from '../../../../../DVWebNodeDraperPlayer/DraperPlayer'
import { DraperPlayerPlacement } from '../../../../../DVWebNodeDraperPlayer/types'
import checkUrlType from '../../../utils/url-type-checker'
import { StorefrontItem } from 'DVWebNodeUtils';
import { VideoContext } from '../../../../../DVWebNodeDraperPlayer/videoContext'
import { FeatureSwitches } from 'widgets/Explore/DVWebNodeStorefront/shared/containers/Storefront'
import { itemToKey } from '../../../utils/itemToKey'

const BASELINE_SIZE = 1500
const PREROLL_ANIMATION_DELAY = 1000

interface HeroElementProps {
  index?: number
  item: StorefrontItem
  autoScrollFunc?: () => void
  autoScrollDelayMilli?: number
  isActive?: boolean
  loadNow?: boolean
  formFactor: string
  featureSwitches?: FeatureSwitches
  canPlay: boolean
  changeLock?: (value: boolean) => void
}

interface HeroElementState {
  imageVisibility: string
  overlayVisible: boolean
}

export class HeroElement extends React.PureComponent<HeroElementProps, HeroElementState> {
  dvWebClientImgLoadFailure: Function

  draperPlayerComponent?: (DraperPlayer | null)

  constructor(props: HeroElementProps) {
    super(props)
    this.dvWebClientImgLoadFailure = () => {
      csm.count('dvWebClientImgLoadFailure')
    }

    this.state = {
      imageVisibility: playerStyles.imageUnBlur,
      overlayVisible: false
    }
  }

  componentDidUpdate(prevProps: HeroElementProps) {
    const playbackChanged = this.props.canPlay != prevProps.canPlay || this.props.item.prerolls != prevProps.item.prerolls
    if (playbackChanged && this.draperPlayerComponent) {
      if (this.props.canPlay && this.props.changeLock) {
        this.props.changeLock(true)
        window.setTimeout(() => this.draperPlayerComponent.startPlayer(), PREROLL_ANIMATION_DELAY)
      } else {
        this.draperPlayerComponent.stop()
      }
    }
  }


  stopPlayer = () => {
    this.draperPlayerComponent && this.draperPlayerComponent.stop()
  }

  changeOverlayVisibility = (visible: boolean) => {
    this.setState({
      overlayVisible: visible,
      imageVisibility: !visible ? playerStyles.imageUnBlur : playerStyles.imageBlur
    })
  }

  render() {
    const link = this.props.item.link
    const image = this.props.item.image!
    return (
      <div data-index={this.props.index}
        tabIndex={0}
        className={cn(style.content, style.imageWrapper, this.state.imageVisibility, 'tst-hero-element')}
      >
        <a
          href={link && checkUrlType(link.url, 'HeroElement')}
          title={(link && link.label) || this.props.item.title}>
          <BasicImage
            alternateText={(image && image.alternateText) || this.props.item.title}
            url={image && image.url} onError={() => this.dvWebClientImgLoadFailure()}
            defaultWidth={BASELINE_SIZE}
            loading={"eager"}
            legacy={this.props.featureSwitches.isIEorLegacyEdge}
          />
        </a>
        {Boolean(this.props.item.prerolls) &&
          <VideoOverlay
            key={itemToKey(this.props.item)}
            item={this.props.item}
            formFactor={this.props.formFactor}
            visible={this.state.overlayVisible}
            stopPlayer={this.stopPlayer}>
            <VideoContext.Consumer>
              {(context) =>
                <DraperPlayer
                  prerolls={this.props.item.prerolls!}
                  link={this.props.item.link ? this.props.item.link.url : undefined}
                  placement={DraperPlayerPlacement.Superhero}
                  ref={(component) => {
                    this.draperPlayerComponent = component
                  }}
                  videoContext={context}
                  playerIsActive={false}
                  enableFullscreen={false}
                  parentListeners={{
                    onPlayStart: () => {
                      this.changeOverlayVisibility(true)
                    },
                    onPlayStop: () => {
                      this.changeOverlayVisibility(false)
                    },
                    onPlayComplete: () => {
                      if (this.props.isActive) {
                        this.props.changeLock && this.props.changeLock(false)
                      }
                    }
                  }} />
              }
            </VideoContext.Consumer>
          </VideoOverlay>}
      </div>
    )
  }
}
